import { render, staticRenderFns } from "./TextoClassificacaoIndicador.vue?vue&type=template&id=0c4b2c90&scoped=true"
import script from "./TextoClassificacaoIndicador.vue?vue&type=script&lang=js"
export * from "./TextoClassificacaoIndicador.vue?vue&type=script&lang=js"
import style0 from "./TextoClassificacaoIndicador.vue?vue&type=style&index=0&id=0c4b2c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b2c90",
  null
  
)

export default component.exports